import { Tag } from "antd";
import { ETransferEmployeeStatus } from "../types/transferEmployee.type";
import NotSet from "./NotSet";

interface TransferEmployeeStatusProps {
	value?: ETransferEmployeeStatus;
}
const TransferEmployeeStatus: React.FC<TransferEmployeeStatusProps> = ({ value }) => {
	if (value === ETransferEmployeeStatus.WAITING) {
		return <Tag color="warning">Waiting Transfer</Tag>;
	} else if (value === ETransferEmployeeStatus.TRANSFERED) {
		return <Tag color="success">Done</Tag>;
	} else if (value === ETransferEmployeeStatus.CANCELED) {
		return <Tag color="error">Canceled</Tag>;
	} else {
		return <NotSet />;
	}
};
export default TransferEmployeeStatus;
